var map = {
	"./Analytics.svg": 161,
	"./IoTCore.svg": 162,
	"./QuickSight.svg": 163,
	"./Sagemaker.svg": 164,
	"./apiGateway.svg": 165,
	"./aws-api-gateway.svg": 166,
	"./awslogo.svg": 167,
	"./bpol.svg": 168,
	"./browser.svg": 169,
	"./cactus.svg": 170,
	"./cam.svg": 171,
	"./camera.svg": 172,
	"./client.svg": 173,
	"./cognito.svg": 174,
	"./customer.svg": 175,
	"./documents.svg": 176,
	"./dropzoneDummy.svg": 98,
	"./dynamodb.svg": 177,
	"./forecast.svg": 178,
	"./gameserver.svg": 179,
	"./kinesis.svg": 180,
	"./lakeFormation.svg": 181,
	"./lambda.svg": 182,
	"./mobile.svg": 183,
	"./mobiles.svg": 184,
	"./redshift.svg": 185,
	"./s3.svg": 186,
	"./ses.svg": 187,
	"./shield.svg": 188,
	"./shop.svg": 189,
	"./sns.svg": 190,
	"./supportEmployee.svg": 191,
	"./users.svg": 192,
	"./vdots.svg": 193,
	"./waterTap.svg": 194,
	"./weatherData.svg": 195,
	"./weatherStation.svg": 196,
	"./webServer.svg": 197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66;